import React from 'react';
import styled from 'styled-components';

import { config } from '_config';
import { theme } from '_constants/theme';

import ContactsSection from 'components/composed/sections/ContactsSection';
import NavigationTabsSection from 'components/composed/sections/NavigationTabsSection';
import PreviousTaxYearsSection from 'components/composed/sections/PreviousTaxYearsSection';

const tabsItems = [
  {
    title: 'Current Tax Year',
    path: `${config.publicUrl}/main/tax-preparation/current`,
  },
  {
    title: 'Previous Years',
    path: `${config.publicUrl}/main/tax-preparation/previous`,
  },
];

const StyledOuterContainer = styled.div`
  display: flex;
  justify-content: center;
  min-height: calc(100vh - 48px);
  width: 100%;
  background-color: ${theme.colors.linkWater};
`;

const StyledInnerContainer = styled.div`
  max-width: ${theme.spaces.large30X * 10}px;
  width: 100%;
  padding-bottom: ${theme.spaces.large10X}px;

  @media ${theme.devices.tablet} {
    padding-left: ${theme.spaces.regular}px;
    padding-right: ${theme.spaces.regular}px;
    padding-bottom: ${theme.spaces.regular}px;
  }
`;

const TaxPreparationPreviousPage = () => {
  return (
    <StyledOuterContainer>
      <StyledInnerContainer>
        <ContactsSection />
        <NavigationTabsSection items={tabsItems} />
        <PreviousTaxYearsSection />
      </StyledInnerContainer>
    </StyledOuterContainer>
  );
};

export default TaxPreparationPreviousPage;
